import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import actions from './actions';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';
import Api from '../../../../../../helpers/api';
import { keyByProperty } from '../../../../../../helpers/core';

const api = new Api('jobs/:id/bookings/:id/update_backups_count');
const jobsListFormDataApi = new Api('jobs/:id/bookings/backups_form_data');
// const checkerApi = new Api('jobs/:id/cancellation_policies/checker');

function* checkIfCancellationPolicyMayApplyRequest({ payload }) {
  const { editForm, id } = payload;
  // const propsArray = Object.values(editForm);
  // const backups = keyByProperty(propsArray, 'name', prop => prop.value);
  // const { backupQuantity } = backups;

  /* try {
    const result = yield call(
      sendRequest,
      checkerApi.updateItem,
      { data: { bookings: { backup_workers_required: backupQuantity } }, id: id[0] },
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      if (result.data.cancellation_policy_may_apply) {
        yield put(actions.toggleCancellationPolicyModal({ isCancellationFeeModalVisible: true }));
      } else {
        yield put(actions.save({ editForm, id }));
      }
      yield put(
        actions.checkCancellationPoliciesSuccess({
          cancellation_policy_may_apply: result.data.cancellation_policy_may_apply,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  } */

  yield put(actions.save({ editForm, id }));
}

function* updateBackups({ payload }) {
  try {
    const { editForm, id, cancellation } = payload;
    const propsArray = Object.values(editForm);
    const backups = keyByProperty(propsArray, 'name', prop => prop.value);
    const { backupQuantity, description, reason } = backups;

    const result = yield call(
      sendRequest,
      api.updateItem,
      {
        data: {
          backups: {
            description,
            backup_workers_required: backupQuantity,
            admin_backup_action_reason_id: reason,
            ...(cancellation && { ...cancellation }),
          },
        },
        id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result?.data) {
      const backupsState = yield select(state => state.EditBackups);

      if (backupsState.isCancellationFeeModalVisible) {
        yield put(actions.toggleCancellationPolicyModal({ isCancellationFeeModalVisible: false }));
      }
      yield put(actions.saveSuccess());
    } else {
      yield put(actions.saveError({ data: result }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData({ payload }) {
  try {
    const result = yield call(sendRequest, jobsListFormDataApi.load, { id: payload.id }, notifications.REQUEST_ERROR);

    if (result?.data) {
      const { data } = result;
      yield put(actions.loadFormDataSuccess({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.SAVE, updateBackups),
    takeEvery(actions.LOAD_FORM_DATA, loadFormData),
    takeEvery(actions.CHECK_CANCELLATION_POLICIES_REQUEST, checkIfCancellationPolicyMayApplyRequest),
  ]);
}
